// extracted by mini-css-extract-plugin
export var active = "_ki-2";
export var recordingDot = "_ki-1";
export var recordingIndicator = "_ki-0";